import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(10);
  const [isAnimating, setIsAnimating] = useState(true);

  const queryParams = new URLSearchParams(location.search)
  const paymentIntentId = queryParams.get('payment_intent')
//   const amount = queryParams.get('amount')

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate('/payments');
    }, 10000);

    return () => {
      clearInterval(interval);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  const handleSkipRedirect = () => {
    navigate('/dashboard');
  };

  return (
    <div className="payment-success-container">
      {/* Animated background elements */}
      <div className="background-elements">
        <div className="grid-background"></div>
        <div className="floating-orb orb-1"></div>
        <div className="floating-orb orb-2"></div>
        <div className="floating-orb orb-3"></div>
        <div className="glow-effect glow-1"></div>
        <div className="glow-effect glow-2"></div>
      </div>

      {/* Main content */}
      <div className="success-content">
        {/* Checkmark animation */}
        <div className="checkmark-container">
          <svg
            className="checkmark"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <div className="checkmark-ring"></div>
          <div className="checkmark-ring ring-2"></div>
        </div>

        {/* Main text content */}
        <h1 className="success-title">Payment Successful!</h1>
        <p className="success-message">
          Your transaction has been processed securely.
        </p>

        {/* Transaction details */}
        <div className="transaction-details">
          <div className="detail-item">
            <span className="detail-label">Payment ID</span>
            <span className="detail-value">{paymentIntentId}</span>
          </div>
          {/* <div className="detail-separator"></div>
          <div className="detail-item">
            <span className="detail-label">Amount</span>
            <span className="detail-value">${amount}</span>
          </div> */}
        </div>

        {/* Countdown section */}
        <div className="countdown-section">
          <p className="countdown-text">
            Redirecting in <span className="countdown-number">{countdown}s</span>
          </p>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${(countdown / 10) * 100}%` }}
            ></div>
          </div>
        </div>

        {/* Action button */}
        <button className="skip-button" onClick={handleSkipRedirect}>
          <span className="button-text">Go to Dashboard</span>
          <span className="button-arrow">→</span>
        </button>

        {/* Decorative bottom accent */}
        <div className="bottom-accent"></div>
      </div>

      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .payment-success-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          position: relative;
          overflow: hidden;
          font-family: 'Space Grotesk', 'Sora', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        /* Background elements */
        .background-elements {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
        }

        .grid-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image:
            linear-gradient(rgba(100, 150, 200, 0.08) 1px, transparent 1px),
            linear-gradient(90deg, rgba(100, 150, 200, 0.08) 1px, transparent 1px);
          background-size: 40px 40px;
          animation: gridScroll 8s linear infinite;
        }

        @keyframes gridScroll {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(40px);
          }
        }

        .floating-orb {
          position: absolute;
          border-radius: 50%;
          background: radial-gradient(circle at 30% 30%, rgba(100, 150, 200, 0.25), rgba(100, 150, 200, 0.05));
          filter: blur(60px);
          animation: float 8s ease-in-out infinite;
        }

        .orb-1 {
          width: 300px;
          height: 300px;
          top: -100px;
          right: -50px;
          animation-delay: 0s;
        }

        .orb-2 {
          width: 250px;
          height: 250px;
          bottom: -80px;
          left: 10%;
          background: radial-gradient(circle at 30% 30%, rgba(150, 100, 200, 0.2), rgba(150, 100, 200, 0.03));
          animation-delay: 3s;
        }

        .orb-3 {
          width: 200px;
          height: 200px;
          top: 50%;
          right: 5%;
          background: radial-gradient(circle at 30% 30%, rgba(100, 180, 200, 0.15), rgba(100, 180, 200, 0.03));
          animation-delay: 6s;
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(30px) scale(1.05);
          }
        }

        .glow-effect {
          position: absolute;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(100, 150, 200, 0.12), transparent);
          animation: pulse 4s ease-in-out infinite;
        }

        .glow-1 {
          width: 500px;
          height: 500px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation-delay: 0s;
        }

        .glow-2 {
          width: 400px;
          height: 400px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation-delay: 2s;
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 0.3;
            transform: translate(-50%, -50%) scale(1);
          }
          50% {
            opacity: 0.6;
            transform: translate(-50%, -50%) scale(1.1);
          }
        }

        /* Main content */
        .success-content {
          position: relative;
          z-index: 10;
          text-align: center;
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(100, 150, 200, 0.2);
          border-radius: 24px;
          padding: 60px 50px;
          max-width: 500px;
          animation: slideUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), inset 0 1px 1px rgba(100, 150, 200, 0.1);
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Checkmark animation */
        .checkmark-container {
          position: relative;
          width: 100px;
          height: 100px;
          margin: 0 auto 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .checkmark {
          width: 100%;
          height: 100%;
          color: #00ADF0;
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          animation: checkmarkDraw 0.8s ease forwards 0.3s;
          filter: drop-shadow(0 0 8px rgba(0, 173, 240, 0.4));
        }

        @keyframes checkmarkDraw {
          to {
            stroke-dashoffset: 0;
          }
        }

        .checkmark-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border: 3px solid rgba(0, 173, 240, 0.3);
          border-radius: 50%;
          animation: ringScale 0.8s ease forwards;
          top: 0;
          left: 0;
        }

        .checkmark-ring.ring-2 {
          border-color: rgba(0, 173, 240, 0.15);
          animation: ringScale 0.8s ease forwards 0.2s;
          animation-delay: 0.2s;
        }

        @keyframes ringScale {
          from {
            transform: scale(0.8);
            opacity: 1;
          }
          to {
            transform: scale(1.3);
            opacity: 0;
          }
        }

        /* Text content */
        .success-title {
          font-size: 32px;
          font-weight: 700;
          background: linear-gradient(135deg, #00ADF0 0%, #00d4ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 12px;
          letter-spacing: -0.5px;
          animation: fadeIn 0.8s ease 0.4s both;
        }

        .success-message {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.6);
          margin-bottom: 35px;
          line-height: 1.6;
          animation: fadeIn 0.8s ease 0.5s both;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        /* Transaction details */
        .transaction-details {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          margin-bottom: 40px;
          padding: 20px;
          background: rgba(0, 173, 240, 0.05);
          border-radius: 16px;
          border: 1px solid rgba(0, 173, 240, 0.15);
          animation: fadeIn 0.8s ease 0.6s both;
        }

        .detail-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
        }

        .detail-label {
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: rgba(0, 0, 0, 0.5);
          font-weight: 600;
        }

        .detail-value {
          font-size: 18px;
          font-weight: 600;
          color: #00ADF0;
          font-family: 'Courier New', monospace;
        }

        .detail-separator {
          width: 1px;
          height: 40px;
          background: linear-gradient(180deg, transparent, rgba(0, 173, 240, 0.25), transparent);
        }

        /* Countdown section */
        .countdown-section {
          margin-bottom: 30px;
          animation: fadeIn 0.8s ease 0.7s both;
        }

        .countdown-text {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.6);
          margin-bottom: 12px;
        }

        .countdown-number {
          color: #00ADF0;
          font-weight: 700;
          font-size: 16px;
          font-family: 'Courier New', monospace;
        }

        .progress-bar {
          width: 100%;
          height: 3px;
          background: rgba(0, 173, 240, 0.12);
          border-radius: 2px;
          overflow: hidden;
          position: relative;
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #00ADF0, #00d4ff);
          border-radius: 2px;
          transition: width 1s linear;
          box-shadow: 0 0 8px rgba(0, 173, 240, 0.5);
        }

        /* Button */
        .skip-button {
          width: 100%;
          padding: 14px 24px;
          font-size: 15px;
          font-weight: 600;
          color: #ffffff;
          background: linear-gradient(135deg, #00ADF0 0%, #00d4ff 100%);
          border: none;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          position: relative;
          overflow: hidden;
          animation: fadeIn 0.8s ease 0.8s both;
          font-family: 'Space Grotesk', sans-serif;
          letter-spacing: 0.5px;
        }

        .skip-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s;
        }

        .skip-button:hover::before {
          left: 100%;
        }

        .skip-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 173, 240, 0.4);
        }

        .skip-button:active {
          transform: translateY(0);
        }

        .button-text {
          position: relative;
          z-index: 1;
        }

        .button-arrow {
          position: relative;
          z-index: 1;
          transition: transform 0.3s ease;
        }

        .skip-button:hover .button-arrow {
          transform: translateX(3px);
        }

        /* Bottom accent */
        .bottom-accent {
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(0, 173, 240, 0.4), transparent);
        }

        /* Responsive design */
        @media (max-width: 600px) {
          .success-content {
            padding: 40px 30px;
            margin: 20px;
          }

          .success-title {
            font-size: 28px;
          }

          .success-message {
            font-size: 15px;
          }

          .transaction-details {
            flex-direction: column;
            gap: 15px;
          }

          .detail-separator {
            width: 40px;
            height: 1px;
          }

          .checkmark-container {
            width: 80px;
            height: 80px;
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentSuccess;